/*
 * curried version of Array.prototype.map
 *
 * arrayMap(v => v + 1)([ 1 ]) -> [ 2 ]
 */

module.exports = function arrayMap (mapper) {
  return function (array) { return array.map(mapper) } 
}
